import { render, staticRenderFns } from "./PhonesWidget.vue?vue&type=template&id=1a13ad9a&scoped=true"
import script from "./PhonesWidget.vue?vue&type=script&lang=js"
export * from "./PhonesWidget.vue?vue&type=script&lang=js"
import style0 from "./PhonesWidget.vue?vue&type=style&index=0&id=1a13ad9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a13ad9a",
  null
  
)

/* custom blocks */
import block0 from "./PhonesWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports